import { mountScenarioScreen, scenarioKey, SCENARIO_MAX_MS } from '../../my_path/scenarioScreen';

export default function showMyPathScenario(chatId, chatElement) {
  let data;
  try {
    const key = scenarioKey(chatId);
    const stored = sessionStorage.getItem(key);
    sessionStorage.removeItem(key);
    if (!stored) return;
    data = JSON.parse(stored);
  } catch (_) { return; }
  if (!data || !chatElement || String(data.chatId) !== String(chatId) || !data.imageUrl ||
      !Number.isFinite(data.shownAt) || Date.now() - data.shownAt >= SCENARIO_MAX_MS ||
      window.performance?.getEntriesByType?.('navigation')[0]?.type === 'reload') return;

  let overlay, observer, fadeTimer;
  const remove = () => {
    clearTimeout(fadeTimer);
    observer?.disconnect();
    overlay?.remove();
    document.removeEventListener('turbolinks:before-cache', remove);
    window.removeEventListener('pagehide', remove);
  };
  overlay = mountScenarioScreen(data, remove);
  const check = () => {
    // Both streamed and server-rendered replies use this markup. User bubbles
    // have .self; empty streaming placeholders must not release the screen.
    const ready = [...chatElement.querySelectorAll('.chat-message:not(.self) .chat-message-detail')]
      .some(element => element.textContent.trim());
    if (!ready) return;
    observer.disconnect();
    overlay.screen.style.opacity = '0';
    fadeTimer = setTimeout(remove, 250);
  };
  observer = new MutationObserver(check);
  observer.observe(chatElement, { childList: true, subtree: true, characterData: true });
  document.addEventListener('turbolinks:before-cache', remove);
  window.addEventListener('pagehide', remove);
  check();
}
